export const DICTIONARY = {
  /**
   * 合同类型
   */
  CONTRACT_TYPE: {
    SALE: {
      value: 0,
      name: "供销合同"
    },
    RENT: {
      value: 1,
      name: "租赁合同"
    },
    CONTRACT: {
      value: 2,
      name: "施工承包合同"
    },
    SUBPACKAGE: {
      value: 3,
      name: "专业分包合同"
    },
  },
  TAX_RATE: {
    TAX_RATE_1: {
      value: 0,
      name: "0%"
    },
    TAX_RATE_2: {
      value: 0.03,
      name: "3%"
    },
    TAX_RATE_3: {
      value: 0.05,
      name: "5%"
    },
    TAX_RATE_4: {
      value: 0.06,
      name: "6%"
    },
    TAX_RATE_5: {
      value: 0.09,
      name: "9%"
    },
    TAX_RATE_6: {
      value: 0.1,
      name: "10%"
    },
    TAX_RATE_7: {
      value: 0.11,
      name: "11%"
    },
    TAX_RATE_8: {
      value: 0.13,
      name: "13%"
    },
    TAX_RATE_9: {
      value: 0.16,
      name: "16%"
    },
    TAX_RATE_10: {
      value: 0.17,
      name: "17%"
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/dictionary.js